export default __webpack_public_path__ + "static/media/zombie_assault.abd13c2f.png";